import withErrorCheck from "../CheckError";
import { IGroupMembers } from "@grassrootly/api/entities";
import server from "../Server";

export const GetGroupMembers = async (gid: number): Promise<IGroupMembers | null> => {
  const groupMembers = withErrorCheck(
    // @ts-ignore
    await server.rpc("group_players_with_total_experience", { gid })
  );

  if (!groupMembers) return null;

  return groupMembers;
};
